document.addEventListener("DOMContentLoaded", function (event) {
  function scrollToTop() {
    let isScrolling = false;
    let lastScrollTop = 0; // 上次滚动的高度

    $(window).scroll(function () {
      let currentScrollTop = $(window).scrollTop();

      // 判断是否滚动大于500并且是向上滚动
      if (currentScrollTop > 500 && currentScrollTop < lastScrollTop) {
        if (!isScrolling) {
          $("#back-top").fadeIn(); // 淡入效果
        }
      } else {
        $("#back-top").fadeOut(); // 淡出效果
      }

      // 更新上次滚动的高度
      lastScrollTop = currentScrollTop;
    });

  $(document).on('click', '#back-top', function() {
      isScrolling = true;
      setTimeout(() => {
        isScrolling = false;
      }, 1000);
      $("html,body").animate({ scrollTop: 0 }, 1000);
      document.querySelector('[tabindex="0"]').focus();
    });
  $(document).on('keydown', '#back-top', function(e) {
    if(e.key == 'Enter' || e.key == ' '){
        e.preventDefault(); // 若要触发空格键事件，且不触发空格导致的页面滚动默认事件
        e.stopPropagation(); // 阻止事件冒泡
        $(this).click();
      }
    });
  }
  let scriptLoaded = false;
  let interactionTimeout;

  // List of CSS links URLs
  function humanInteraction() {
    if (!scriptLoaded) {
      let output = false;


      scrollToTop();
      output = true;

      if (output) {
        console.log('snippets-back-top.js load.');
      } else {
        console.warn('Keihen: No valid script or style URLs found.');
      }

      scriptLoaded = true;
      clearTimeout(interactionTimeout);
    }
  }

  document.addEventListener('click', humanInteraction);
  document.addEventListener('scroll', humanInteraction);
  document.addEventListener('mousemove', humanInteraction);
  document.addEventListener('keydown', humanInteraction);
  document.addEventListener('touchstart', humanInteraction);

  // Set a timeout to trigger the script after 5 seconds of inactivity
  interactionTimeout = setTimeout(function () {
    if (!scriptLoaded) {
      humanInteraction();
    }
  }, 40000);
});

